import SectionReveal from './SectionReveal.jsx';

/**
 * Consistent section heading: eyebrow + title + optional subtitle.
 */
export default function SectionHeading({ eyebrow, title, subtitle, align = 'center' }) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <SectionReveal
      className={`flex flex-col gap-4 ${alignment}`}
    >
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="max-w-3xl text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">
        <span className="heading-gradient">{title}</span>
      </h2>
      {subtitle && (
        <p className="max-w-2xl text-base text-silver/80 sm:text-lg">{subtitle}</p>
      )}
    </SectionReveal>
  );
}
